'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-929adab5.js');
var React = require('react');
var styled = require('styled-components');
var TextField = require('@mui/material/TextField');
var components_PhoneNumber_PhoneInput = require('./PhoneInput.js');
var components_PhoneNumber_PhoneInputNoMask = require('./PhoneInputNoMask.js');
var helpers_styles = require('../../helpers/styles.js');
require('react-text-mask');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var TextField__default = /*#__PURE__*/_interopDefaultLegacy(TextField);

var StyledTextField = styled__default["default"](TextField__default["default"])(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), helpers_styles.muiInputWidthStyles, helpers_styles.muiInputHeightStyles, helpers_styles.muiInputPaddingStyles, helpers_styles.muiInputDisabledStyles, helpers_styles.muiInputErrorStyles, helpers_styles.muiInputBorderStyles, helpers_styles.muiInputTextStyles);
var PhoneNumber = React__default["default"].forwardRef(function (_a, ref) {
    var label = _a.label, _b = _a.disabled, disabled = _b === void 0 ? false : _b, hide_mask = _a.hide_mask, error = _a.error, onChange = _a.onChange, value = _a.value, name = _a.name, className = _a.className, placeholder = _a.placeholder, autocomplete = _a.autocomplete, onBlur = _a.onBlur, onFocus = _a.onFocus;
    return (React__default["default"].createElement(StyledTextField, { className: className, inputRef: ref, error: !!error, helperText: error, FormHelperTextProps: {
            'aria-live': 'assertive',
        }, disabled: disabled, value: value, onChange: function (event) {
            return onChange && onChange(event.target.value);
        }, label: label, placeholder: placeholder, variant: "outlined", id: name, name: name, InputLabelProps: {
            htmlFor: name,
            shrink: value ? value.length > 0 : undefined,
        }, InputProps: {
            inputComponent: hide_mask ? components_PhoneNumber_PhoneInputNoMask["default"] : components_PhoneNumber_PhoneInput["default"],
            autoComplete: autocomplete,
        }, onBlur: onBlur, onFocus: onFocus }));
});
var templateObject_1;

exports["default"] = PhoneNumber;
